<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <v-app id="cheerfulgive-accheckin">
    <v-main>
      <v-container fluid class="mb-8">
        <div class="content-div">
          <!-- 上方左右側按鈕 -->
          <div class="d-flex justify-space-between">
            <v-btn color="primary" elevation="2" outlined x-large class="text-xs-h6 text-sm-h6" :ripple="false" @click="back">
              <icon-reply class="cheerfulgive-icon" />
              {{ $t('back') }}
            </v-btn>
          </div>
          <div class="ac-meta">
            <v-row justify="center">
              <img src="@/assets/images/cheerfulgive-logo.png" alt="cheerfulgive-logo" class="logo-img">
            </v-row>
            <v-row justify="center" class="pt-10">
              <h2>{{ $t('acScanQrCode') }}</h2>
            </v-row>
            <v-row justify="center">
              <hr style="width:12em; background-color:#FEAA3C; height:1.5px; border-width:0;">
            </v-row>
          </div>
          <div class="mt-10">
            <v-row justify="center">
              <!-- 活動 -->
              <v-col cols="12" sm="11" class="pt-0 pb-0">
                <div class="text-xs-h6 text-sm-h6 d-flex align-center mb-2">
                  {{ $t('activityName') }}
                </div>
                <v-select
                  v-model="selectedActivity"
                  :items="scannableActivities"
                  :label="$t('selectActivity')"
                  outlined
                >
                  <!-- 插槽 https://vuetifyjs.com/zh-Hans/api/v-select/#slots -->
                  <!-- item 定義自定義"項(下拉顯示)"外觀 -->
                  <template v-slot:item="{item}">
                    {{item.title}}
                  </template>
                  <!-- selection 定義自定義"選擇器(選定顯示)"外觀 -->
                  <template v-slot:selection="{item}">
                    {{item.title}}
                  </template>
                </v-select>
              </v-col>
              <!-- 場次 -->
              <v-col cols="12" sm="11" class="pt-0 pb-0">
                <div class="text-xs-h6 text-sm-h6 d-flex align-center mb-2">
                  {{ $t('sessionName') }}
                </div>
                <v-select
                  v-model="selectedSession"
                  :disabled="sessionDisable"
                  :items="scannableActivitiesSession"
                  :label="$t('selectSession')"
                  outlined
                >
                  <template v-slot:item="{item}">
                    {{item.title}}
                  </template>
                  <template v-slot:selection="{item}">
                    {{item.title}}
                  </template>
                </v-select>
              </v-col>
              <!-- 課堂 -->
              <v-col cols="12" sm="11" class="pt-0 pb-0">
                <div class="text-xs-h6 text-sm-h6 d-flex align-center mb-2">
                  {{ $t('lessonName') }}
                </div>
                <v-select
                  v-model="selectedLesson"
                  :disabled="lessonDisable"
                  :items="scannableActivitiesLesson"
                  :label="$t('selectLesson')"
                  outlined
                >
                  <template v-slot:item="{item}">
                    {{item.title}}
                  </template>
                  <template v-slot:selection="{item}">
                    {{item.title}}
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-btn depressed style="background-color:#FEAA3C; color:#fff;" class="pl-7 pr-7" @click="submit">{{ $t('submit') }}</v-btn>
            </v-row>
          </div>
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import IconReply from '@/assets/icons/reply.vue'
import Api from '../../apis'
export default {
  components: {
    IconReply
  },
  data () {
    return {
      scannableActivities: null,
      selectedActivity: null,
      scannableActivitiesSession: null,
      sessionDisable: true,
      selectedSession: null,
      scannableActivitiesLesson: null,
      lessonDisable: true,
      selectedLesson: null
    }
  },
  created () {
    Api.activity.getScannableActivities().then(res => {
      // console.log(res)
      this.scannableActivities = res.data
      this.selectedActivity = res.data[0]
    })
  },
  methods: {
    back () {
      this.$router.push('/menu')
    },
    submit () {
      // console.log(this.selectedActivity.title + ',' + this.selectedSession.title + ',' + this.selectedLesson.title)
      this.$router.push(`/scanQrCode?id=${this.selectedLesson.id}`)
    }
  },
  watch: {
    selectedActivity (newVal) {
      // console.log(newVal)
      if (this.selectedActivity) {
        this.sessionDisable = false
        this.scannableActivitiesSession = newVal.sessions
        this.selectedSession = newVal.sessions[0]
      }
    },
    selectedSession (newVal) {
      if (this.selectedSession) {
        this.lessonDisable = false
        this.scannableActivitiesLesson = newVal.lessons
        this.selectedLesson = newVal.lessons[0]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#cheerfulgive-accheckin {

  .content-div {
    margin: 5%;

    .cheerfulgive-icon {
      margin-right: 5px;
    }
  }
}

.logo-img {
  width: 80%;
  margin-top: 60px;
}

.ac-meta h2 {
  color:#FEAA3C;
  font-size: 1.6em;
  letter-spacing: 3px;
}

@media screen and (max-width:767px) {
  .logo-img {
    width: 90%;
    margin-top: 40px;
  }

  .ac-meta h2 {
    color:#FEAA3C;
    font-size: 1.3em;
    letter-spacing: 3px;
  }
}
</style>
